import { createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f6b7cbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "Carte Confituur | Contact", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("link", {
  rel: "canonical",
  href: "https://www.carteconfituur.be/contact"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "description",
  content: "Contacteer Carte Confituur"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:title",
  content: "Carte Confituur | Contact"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:url",
  content: "https://www.carteconfituur.be/contact"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:description",
  content: "Contacteer Carte Confituur"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  property: "og:type",
  content: "article"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "twitter:title",
  content: "Carte Confituur | Contact"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "twitter:description",
  content: "Contacteer Carte Confituur"
}, null, -1))
const _hoisted_10 = { class: "contact" }
const _hoisted_11 = { class: "contactWrapper" }
const _hoisted_12 = { class: "upperPart" }
const _hoisted_13 = { class: "leftSide" }
const _hoisted_14 = { class: "location" }
const _hoisted_15 = { class: "locationImage" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"rightSide\" data-v-3f6b7cbe><div class=\"rightSideWrapper\" data-v-3f6b7cbe><div class=\"textPart\" data-v-3f6b7cbe><div class=\"title\" data-v-3f6b7cbe>ZIN OM SAMEN TE WERKEN?</div><div class=\"text\" data-v-3f6b7cbe><p data-v-3f6b7cbe> Nieuwsgierig naar meer, wil je graag jouw creatieve plannen bespreken of gewoon zin in een goeie kop koffie? Ik hoor het graag van je! <br data-v-3f6b7cbe><br data-v-3f6b7cbe><strong data-v-3f6b7cbe>Enkel op afspraak</strong>. <br data-v-3f6b7cbe>Stuur jouw vragen of ideeën naar <a href=\"mailto:hallo@carteconfituur.be\" data-v-3f6b7cbe>hallo@carteconfituur.be</a> en dan zien of horen we elkaar snel. </p><p data-v-3f6b7cbe> Liefs, Yasmine </p></div></div><div class=\"callToAction\" data-v-3f6b7cbe><a href=\"mailto:hallo@carteconfituur.be\" data-v-3f6b7cbe>Laat van je horen</a></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Marker = _resolveComponent("Marker")!
  const _component_GoogleMap = _resolveComponent("GoogleMap")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_1
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_2
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_3
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_4
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_5
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_6
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_7
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_8
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _hoisted_9
    ])),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_GoogleMap, {
                  "api-key": "AIzaSyCHOZ9Vm8_DugEbjCFpphZm45QlOJkjC_8",
                  style: {"width":"100%","height":"500px"},
                  center: _ctx.center,
                  zoom: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Marker, {
                      options: { position: _ctx.center}
                    }, null, 8, ["options"])
                  ]),
                  _: 1
                }, 8, ["center"])
              ])
            ])
          ]),
          _hoisted_16
        ])
      ])
    ])
  ], 64))
}